<section class="menu-section">
  <div class="container">
    <div class="skeleton" *ngIf="!products?.length; else productExists">
      <div class="skeleton__image"></div>
      <div class="skeleton__text-container">
        <div class="skeleton__title"></div>
        <div class="skeleton__text"></div>
        <div class="skeleton__text"></div>
        <div class="skeleton__text"></div>
        <div class="skeleton__text"></div>
        <div class="skeleton__text"></div>
      </div>
    </div>
    <ng-template #productExists>
      <div class="row align-items-center">
        <div class="col-md-5">
          <div class="first">

            <div class="share-button">
              <app-share-to-social [data]="social_data" [size]="16" [text_color]="'black'"></app-share-to-social>
            </div>

            <img loading="lazy" [src]="selected_product.product_url" class="product-img" [alt]="selected_product.title">

            <div class="d-flex flex-row mt-3">
              <div *ngFor="let product of products" (click)="setSelectedProduct(product)"
                class="product-img-smaller {{product.id === selected_product?.id ? 'active' : ''}}">
                <img loading="lazy" [src]="product.product_url" width="100" height="100" [alt]="product.title">
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="qr_categories.memories === qr_category">
          <div class="col-md-7 mt-5 mt-md-0 second">
            <h1>Shared Photo Album</h1>
            <h6>
              Memories is an all-in-one event photo sharing solution. It uses a unique QR code that guests
              can
              scan to instantly upload photos and videos to a centralised online gallery. No app downloads
              or
              logins required!
            </h6>
            <br>
            <h6>
              Hassle-free photo sharing! We will email your unique Memories QR code(s) and activation code
              immediately after purchase.
            </h6>
            <ng-container *ngIf="selected_product_price">
              <br>
              <div class="d-flex flex-row price-row">
                <p *ngIf="selected_product_price.old_price > selected_product_price.price" class="old-price">
                  {{selected_product_price.old_price | currency: selected_product_price.currency}}
                </p>
                <p class="price">
                  {{selected_product_price.price | currency: selected_product_price.currency}}
                </p>
                <div class="percentage-difference">
                  <span *ngIf="selected_product_price.old_price > selected_product_price.price">
                    -{{priceDifference()}}%
                  </span>
                </div>
              </div>

              <div class="pt-3 pb-2">
                <b *ngIf="selected_product_price.benefits.unlimited_scans">Unlimited scans &
                  unlimited storage for:</b>
              </div>

              <div class="d-flex flex-row price-variation-row">
                <ng-container *ngFor="let price of selected_product.prices">
                  <div class="d-flex flex-row pvr-container {{ price.id === selected_product_price.id ? 'active' : ''}}"
                    (click)="selected_product_price = price">
                    <i class="bi {{ price.id === selected_product_price.id ? 'bi-circle-fill' : 'bi-circle'}}"></i>
                    <span *ngIf="price.benefits.expiry.enable">
                      {{price.benefits.expiry.unit}}
                      {{functionService.ucfirst(this.functionService.pluralize(price.benefits.expiry.in,
                      price.benefits.expiry.unit))}}
                    </span>
                    <span *ngIf="!price.benefits.expiry.enable">
                      Lifetime
                    </span>
                  </div>
                </ng-container>
              </div>

              <div class="pt-4 mb-n2">
                <small>Quantity:</small>
              </div>
              <div class="item-to-cart">
                <button [disabled]="cart_item.quantity <= 1"
                  (click)="cart_item.quantity = cart_item.quantity - (cart_item.quantity <= 1 ? 0 : 1)"><i
                    class="bi bi-dash"></i></button>
                <strong>{{cart_item.quantity}}</strong>
                <button [disabled]="cart_item.quantity >= 100"
                  (click)="cart_item.quantity = cart_item.quantity + (cart_item.quantity >= 100 ? 0 : 1)"><i
                    class="bi bi-plus-lg"></i></button>
              </div>
              <br>
              <br>
              <div class="add-to-cart-wrapper">
                <div class="add-to-cart-parent">
                  <a class="btn btn-success mb-3" [ngStyle]="{'visibility': products?.length ? 'visible' : 'hidden'}"
                    (click)="addToCart()">
                    <ng-container *ngIf="!alacarte_session?.busy">
                      <i class="bi bi-cart me-2"></i>
                      Add to cart
                    </ng-container>
                    <app-inline-loader *ngIf="alacarte_session?.busy"></app-inline-loader>
                  </a>
                  <div class="email-prompt animated fadeIn" *ngIf="taking_email">
                    <div class="header">
                      <p>
                        Please enter your email to add this item to cart
                      </p>
                      <i class="bi bi-x" (click)="taking_email = false"></i>
                    </div>
                    <div class="input-group">
                      <input type="email" maxlength="60" [(ngModel)]="checkout_email"
                        [ngModelOptions]="{standalone: true}" required class="form-control">
                      <button class="btn btn-success" (click)="addToCart()">
                        <ng-container *ngIf="!alacarte_session?.busy">
                          Proceed
                        </ng-container>
                      </button>
                    </div>
                  </div>
                </div>
                <p *ngIf="alacarte_session?.cart.items.length">
                  <a class="btn btn-primary" routerLink="/cart">
                    <i class="bi bi-arrow-right me-2"></i>
                    View cart
                  </a>
                </p>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-template>
  </div>
</section>